<template>
  <!-- Variant 1 -->
  <section
    v-if="variants.v1 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div
      class="tw-mb-10 tw-flex tw-flex-col tw-items-start tw-self-start tw-text-start md:tw-items-center md:tw-self-center md:tw-text-center lg:tw-mb-16"
    >
      <small v-if="vars.altTitleText"> {{ vars.altTitleText }}</small>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div
      class="tw-flex tw-w-full tw-flex-col tw-gap-10 tw-gap-y-10 tw-text-center !tw-text-white md:tw-gap-y-20 lg:tw-flex-row"
    >
      <div
        v-for="(member, index) in members"
        :key="index"
        @click="toggleTeamMemberDetailPopup(member, true)"
        class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500 hover:tw-cursor-pointer md:hover:tw-scale-105"
      >
        <LibraryImage :w-ratio="14" :h-ratio="9" :src="member.member_photo" style="border-radius: var(--rounded)" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-50"
          style="border-radius: var(--rounded)"
        ></div>
        <div
          class="agent-info-v1 tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-translate-y-full tw-transform tw-flex-col tw-items-center tw-gap-5 tw-overflow-hidden tw-p-4 tw-text-center tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-pointer-events-auto group-hover:tw-translate-y-0 group-hover:tw-opacity-100"
        >
          <div class="tw-flex tw-flex-col">
            <h6>{{ member.member_name }}</h6>
            <p class="n-semibold">{{ member.member_role }}</p>
          </div>
          <button class="n-link">VIEW MORE DETAILS</button>
        </div>
      </div>
    </div>
    <nuxt-link
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-10 tw-self-start md:tw-self-center`"
      :to="vars.buttonLinkUrl"
      v-if="vars.buttonLinkUrl"
    >
      <div class="n-btn-container">
        <div class="n-btn-group">
          <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
        </div>
      </div>
    </nuxt-link>

    <MotionGroup :preset="vars.animationText ? vars.animationText : 'popVisible'" :duration="400" is="div">
      <popup v-if="selectedMember && popupConfig.isActive" :config="popupConfig" custom-width="90%">
        <template #content>
          <div class="tw-grid tw-h-full tw-w-full tw-grid-cols-12 tw-gap-y-4 tw-py-4 lg:tw-gap-x-6">
            <div class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-justify-center lg:tw-col-span-7">
              <h2>{{ selectedMember.member_name }}</h2>
              <p class="n-semibold tw-mt-2">{{ selectedMember.member_role }}</p>
              <div class="tw-py-8">
                <div v-if="selectedMember.member_email" class="tw-flex tw-items-center tw-gap-1 tw-pb-3">
                  <nuxt-link :to="`mailto:${selectedMember.member_email}`" class="n-link">
                    <p class="n-semibold">{{ selectedMember.member_email }}</p>
                  </nuxt-link>
                </div>
                <div v-if="selectedMember.member_phone" class="tw-flex tw-items-center tw-gap-1">
                  <nuxt-link :to="`tel:${selectedMember.member_phone}`" class="n-link">
                    <p class="n-semibold">{{ selectedMember.member_phone }}</p>
                  </nuxt-link>
                </div>
              </div>
              <div class="tw-flex tw-flex-col tw-gap-3" v-html="selectedMember.popup_descriptions"></div>
              <nuxt-link
                :external="true"
                :class="`n-${selectedMember.popup_button_type} n-btn tw-mt-12 tw-max-w-fit`"
                :to="selectedMember.popup_button_link"
                v-if="selectedMember.popup_button_link"
              >
                <div class="n-btn-container">
                  <div class="n-btn-group">
                    <div class="n-btn-t1">{{ selectedMember.popup_button_label }}</div>
                    <div class="n-btn-t2">{{ selectedMember.popup_button_label }}</div>
                  </div>
                </div>
              </nuxt-link>
            </div>
            <div
              class="tw-order-first tw-col-span-12 tw-flex tw-items-center tw-justify-center lg:tw-order-none lg:tw-col-span-5"
            >
              <div style="position: relative; height: 100%; width: 100%">
                <iframe
                  :src="selectedMember?.popup_video"
                  width="100%"
                  height="100%"
                  style="position: relative; top: 0; left: 0; aspect-ratio: 16/9"
                />
              </div>
            </div>
          </div>
        </template>
      </popup>
    </MotionGroup>

    <library-popups-video-popup
      v-if="selectedMember?.popup_video"
      :videoUrl="selectedMember?.popup_video"
      v-model:is-visible="isVisible"
    />
  </section>

  <!-- Variant 2 -->
  <section
    v-if="variants.v2 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-self-center tw-text-center lg:tw-mb-6">
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div class="tw-w-full !tw-text-white">
      <Swiper
        :modules="[SwiperPagination]"
        @slideChange="onSlideChange"
        @swiper="onSwiper"
        :pagination="false"
        :loop="true"
        :slides-per-view="1"
        :space-between="32"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1536: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
        }"
        class="tw-w-full"
      >
        <SwiperSlide v-for="(member, index) in members" :key="index">
          <nuxt-link class="n-link" :to="member.member_link" :external="true">
            <div
              class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500"
            >
              <LibraryImage
                :w-ratio="9"
                :h-ratio="12"
                :src="member.member_photo"
                style="border-radius: var(--rounded)"
              />
              <div
                class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
                style="border-radius: var(--rounded)"
              ></div>
              <div
                class="agent-info-v2 tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-translate-y-full tw-transform tw-flex-col tw-items-center tw-gap-5 tw-overflow-hidden tw-p-4 tw-text-center tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-pointer-events-auto group-hover:-tw-translate-y-16 group-hover:tw-opacity-100"
              >
                <div class="tw-flex tw-flex-col tw-gap-6">
                  <h6>{{ member.member_name }}</h6>
                  <p class="n-semibold">{{ member.member_role }}</p>
                </div>
              </div>
            </div>
          </nuxt-link>
        </SwiperSlide>
      </Swiper>
      <div>
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v5"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>
    <nuxt-link
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-8 tw-self-center`"
      :to="vars.buttonLinkUrl"
      v-if="vars.buttonLinkUrl"
    >
      <div class="n-btn-container">
        <div class="n-btn-group">
          <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
        </div>
      </div>
    </nuxt-link>
  </section>

  <!-- Variant 3 -->
  <section
    v-if="variants.v3 === variant"
    class="n-section-primary tw-overflow-hidden"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="left_top"
      :company-key="company.company_key"
    />

    <!-- Başlık -->
    <div
      class="tw-mb-10 tw-flex tw-flex-col tw-items-start tw-self-start tw-text-start md:tw-items-center md:tw-self-center md:tw-text-center lg:tw-mb-16"
    >
      <small v-if="vars.altTitleText">{{ vars.altTitleText }}</small>
      <h2>{{ vars.titleText }}</h2>
    </div>

    <!-- Mobile: swiper slider -->
    <div class="tw-w-full lg:tw-hidden">
      <div class="content-container">
        <div class="swiper-wrapper">
          <Swiper
            :modules="[SwiperPagination]"
            :clickable="true"
            :loop="true"
            :watch-overflow="true"
            @slideChange="onSlideChange"
            :breakpoints="{ 320: { slidesPerView: 1 }, 768: { slidesPerView: 1 } }"
            :spaceBetween="20"
            @swiper="onSwiper"
            class="tw-w-full"
          >
            <SwiperSlide v-for="(member, index) in members" :key="`member-slide-${index}`">
              <div
                @click="
                  String(member?.popup_descriptions || '')
                    .replace(/<[^>]*>/g, '')
                    .trim().length > 0 && toggleTeamMemberDetailPopup(member, true)
                "
                class="tw-group tw-relative tw-mx-auto tw-cursor-pointer tw-overflow-hidden tw-transition-transform tw-duration-500 hover:tw-scale-105"
                style="width: 350px; height: 470px"
              >
                <!-- FOTOĞRAF KATMANLARI -->
                <div class="tw-relative tw-h-full tw-w-full" style="border-radius: var(--rounded)">
                  <LibraryImage
                    :src="member.member_photo"
                    :alt="member.member_name"
                    class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
                    style="border-radius: var(--rounded)"
                  />
                  <div
                    v-if="member.member_hover"
                    class="tw-absolute tw-inset-0 tw-z-10 tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-100"
                    style="border-radius: var(--rounded)"
                  >
                    <LibraryImage
                      :src="member.member_hover"
                      :alt="member.member_name + ' hover'"
                      class="tw-h-full tw-w-full tw-object-cover"
                      style="border-radius: var(--rounded)"
                    />
                  </div>
                </div>

                <!-- Hover overlay (DAİMA aktif) -->
                <div
                  class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-50"
                  style="border-radius: var(--rounded)"
                ></div>

                <!-- Bilgi kutusu (DAİMA hover'da çıksın; CTA yalnız açıklama varsa) -->
                <div
                  class="agent-info-v1 tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-translate-y-full tw-transform tw-flex-col tw-items-center tw-gap-5 tw-p-4 !tw-text-white tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-pointer-events-auto group-hover:tw-translate-y-0 group-hover:tw-opacity-100"
                >
                  <div class="tw-flex tw-flex-col tw-items-center tw-text-center">
                    <h6>{{ member.member_name }}</h6>
                    <p class="n-semibold">{{ member.member_role }}</p>
                  </div>
                  <button
                    v-if="
                      String(member?.popup_descriptions || '')
                        .replace(/<[^>]*>/g, '')
                        .trim().length > 0
                    "
                    class="n-link"
                  >
                    VIEW MORE DETAILS
                  </button>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div class="tw-mt-4">
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v11"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>

    <!-- Desktop: 2×3 Grid -->
    <div class="tw-hidden lg:tw-block">
      <div class="tw-grid tw-grid-cols-3 tw-grid-rows-2 tw-justify-center tw-gap-10">
        <div
          v-for="(member, index) in members"
          :key="index"
          @click="
            String(member?.popup_descriptions || '')
              .replace(/<[^>]*>/g, '')
              .trim().length > 0 && toggleTeamMemberDetailPopup(member, true)
          "
          class="tw-group tw-relative tw-cursor-pointer tw-overflow-hidden tw-transition-transform tw-duration-500 hover:tw-scale-105"
          style="width: 470px; height: 635px"
        >
          <!-- FOTOĞRAF KATMANLARI -->
          <div class="tw-relative tw-h-full tw-w-full" style="border-radius: var(--rounded)">
            <LibraryImage
              :src="member.member_photo"
              :alt="member.member_name"
              class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
              style="border-radius: var(--rounded)"
            />
            <div
              v-if="member.member_hover"
              class="tw-absolute tw-inset-0 tw-z-10 tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-100"
              style="border-radius: var(--rounded)"
            >
              <LibraryImage
                :src="member.member_hover"
                :alt="member.member_name + ' hover'"
                class="tw-h-full tw-w-full tw-object-cover"
                style="border-radius: var(--rounded)"
              />
            </div>
          </div>

          <!-- Hover overlay (DAİMA aktif) -->
          <div
            class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-50"
            style="border-radius: var(--rounded)"
          ></div>

          <!-- Bilgi kutusu (DAİMA hover'da çıksın; CTA yalnız açıklama varsa) -->
          <div
            class="agent-info-v1 tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-translate-y-full tw-transform tw-flex-col tw-items-center tw-gap-5 tw-p-4 !tw-text-white tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-pointer-events-auto group-hover:tw-translate-y-0 group-hover:tw-opacity-100"
          >
            <div class="tw-flex tw-flex-col tw-items-center tw-text-center">
              <h6>{{ member.member_name }}</h6>
              <p class="n-semibold">{{ member.member_role }}</p>
            </div>
            <button
              v-if="
                String(member?.popup_descriptions || '')
                  .replace(/<[^>]*>/g, '')
                  .trim().length > 0
              "
              class="n-link"
            >
              VIEW MORE DETAILS
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Alt buton -->
    <nuxt-link
      v-if="vars.buttonLinkUrl"
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-10 tw-self-start md:tw-self-center`"
      :to="vars.buttonLinkUrl"
    >
      <div class="n-btn-container">
        <div class="n-btn-group">
          <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
        </div>
      </div>
    </nuxt-link>

    <!-- Popup içerikleri -->
    <MotionGroup :preset="vars.animationText || 'popVisible'" :duration="400" is="div">
      <popup v-if="selectedMember && popupConfig.isActive" :config="popupConfig" custom-width="90%">
        <template #content>
          <div class="tw-grid tw-h-full tw-w-full tw-grid-cols-12 tw-gap-y-4 tw-py-4 lg:tw-gap-x-6">
            <!-- Metin kısmı -->
            <div class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-justify-center lg:tw-col-span-7">
              <h2>{{ selectedMember.member_name }}</h2>
              <p class="n-semibold tw-mt-2">{{ selectedMember.member_role }}</p>

              <div class="tw-py-8">
                <div v-if="selectedMember.member_email" class="tw-flex tw-items-center tw-gap-1 tw-pb-3">
                  <nuxt-link :to="`mailto:${selectedMember.member_email}`" class="n-link">
                    <p class="n-semibold" style="color: var(--c-primary)">{{ selectedMember.member_email }}</p>
                  </nuxt-link>
                </div>
                <div v-if="selectedMember.member_phone" class="tw-flex tw-items-center tw-gap-1">
                  <nuxt-link :to="`tel:${selectedMember.member_phone}`" class="n-link">
                    <p class="n-semibold">{{ selectedMember.member_phone }}</p>
                  </nuxt-link>
                </div>
              </div>

              <div class="tw-flex tw-flex-col tw-gap-3" v-html="selectedMember.popup_descriptions"></div>

              <nuxt-link
                v-if="selectedMember.popup_button_link"
                :external="true"
                :class="`n-${selectedMember.popup_button_type} n-btn tw-mt-12 tw-max-w-fit`"
                :to="selectedMember.popup_button_link"
              >
                <div class="n-btn-container">
                  <div class="n-btn-group">
                    <div class="n-btn-t1">{{ selectedMember.popup_button_label }}</div>
                    <div class="n-btn-t2">{{ selectedMember.popup_button_label }}</div>
                  </div>
                </div>
              </nuxt-link>
            </div>

            <!-- Medya kısmı (foto/video) -->
            <div
              class="tw-order-first tw-col-span-12 tw-flex tw-items-center tw-justify-center lg:tw-order-none lg:tw-col-span-5"
            >
              <div class="tw-w-full tw-max-w-[720px]">
                <!-- FOTOĞRAF VARSA -->
                <div
                  v-if="selectedMember?.popup_image || selectedMember?.member_hover"
                  class="tw-relative tw-mx-auto tw-overflow-hidden"
                  style="border-radius: var(--rounded); max-width: 450px; aspect-ratio: 3/4"
                >
                  <LibraryImage
                    :src="selectedMember.popup_image || selectedMember.member_hover"
                    class="tw-h-full tw-w-full tw-object-cover"
                  />
                </div>

                <!-- Video -->
                <div v-if="selectedMember?.popup_video" class="tw-mt-4">
                  <template v-if="selectedMember?.popup_image || selectedMember?.member_photo">
                    <button class="n-link n-btn tw-max-w-fit" @click.stop="isVisible = true">Play Video</button>
                  </template>
                  <template v-else>
                    <div
                      style="
                        position: relative;
                        width: 100%;
                        height: 100%;
                        aspect-ratio: 16/9;
                        border-radius: var(--rounded);
                      "
                    >
                      <iframe
                        :src="selectedMember.popup_video"
                        width="100%"
                        height="100%"
                        style="position: absolute; inset: 0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </popup>
    </MotionGroup>

    <!-- Video Popup fallback -->
    <library-popups-video-popup
      v-if="selectedMember?.popup_video"
      :videoUrl="selectedMember.popup_video"
      v-model:is-visible="isVisible"
    />
  </section>

  <!-- Variant 4 -->
  <section
    v-if="variants.v4 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-self-center tw-text-center lg:tw-mb-6">
      <small v-if="vars.altTitleText">{{ vars.altTitleText }}</small>
      <h2>{{ vars.titleText }}</h2>
    </div>

    <!-- MOBİL: SLIDER (değişmedi) -->
    <div class="tw-w-full !tw-text-white lg:tw-hidden" v-if="members && members.length">
      <Swiper
        :modules="[SwiperPagination]"
        @slideChange="onSlideChange"
        @swiper="onSwiper"
        :pagination="false"
        :loop="true"
        :slides-per-view="1"
        :space-between="24"
        effect="fade"
        :clickable="true"
        :breakpoints="{ 320: { slidesPerView: 1 }, 640: { slidesPerView: 2 } }"
        class="tw-w-full"
      >
        <SwiperSlide v-for="(member, index) in members" :key="`v4m-${index}`">
          <div class="n-link" @click="toggleTeamMemberDetailPopup(member, true)">
            <div class="no-hover shine-effect tw-group tw-relative tw-overflow-hidden tw-rounded-[var(--rounded)]">
              <LibraryImage
                :w-ratio="9"
                :h-ratio="12"
                :src="member.member_photo"
                class="tw-w-full"
                style="border-radius: var(--rounded)"
              />
              <div
                class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
                style="border-radius: var(--rounded)"
              ></div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <div class="tw-mt-4">
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v15"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>

    <!-- MASAÜSTÜ: ÜSTTE 2 BÜYÜK + ALTA 5 KÜÇÜK (v2 hover davranışı) -->
    <div class="tw-hidden lg:tw-block" v-if="members && members.length">
      <div class="tw-mx-auto tw-flex tw-w-full tw-max-w-[1440px] tw-flex-col tw-gap-12 tw-px-6">
        <!-- ÜST 2 BÜYÜK -->
        <div class="tw-mb-6 tw-flex tw-justify-center tw-gap-10">
          <div
            v-for="(member, i) in members.slice(0, 2)"
            :key="`v4f-${i}`"
            class="n-link tw-group tw-block tw-cursor-pointer tw-overflow-hidden tw-rounded-[var(--rounded)] tw-shadow-sm"
            @click="toggleTeamMemberDetailPopup(member, true)"
          >
            <div class="tw-relative tw-h-[620px] tw-w-[460px]">
              <LibraryImage
                :src="member.member_photo"
                class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
              />
              <div
                class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
              ></div>

              <div
                class="agent-info-v2 tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-translate-y-full tw-transform tw-flex-col tw-items-center tw-gap-5 tw-overflow-hidden tw-text-center !tw-text-white tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-pointer-events-auto group-hover:-tw-translate-y-16 group-hover:tw-opacity-100"
              >
                <div class="tw-flex tw-flex-col tw-gap-2">
                  <h3 class="tw-text-white">{{ member.member_name }}</h3>
                  <h6 class="n-semibold tw-mb-6 tw-text-white tw-opacity-90">{{ member.member_role }}</h6>
                  <h6 class="n-link tw-text-white">VIEW MORE DETAILS</h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ALTA 5 KÜÇÜK -->
        <div class="tw-grid tw-grid-cols-5 tw-place-items-center tw-gap-6">
          <div
            v-for="(member, i) in members.slice(2, 7)"
            @click="toggleTeamMemberDetailPopup(member, true)"
            :key="`v4o-${i}`"
            class="n-link tw-group tw-block tw-cursor-pointer tw-overflow-hidden tw-rounded-[var(--rounded)] tw-shadow-sm"
          >
            <div class="tw-relative tw-h-[320px] tw-w-[240px]">
              <LibraryImage
                :src="member.member_photo"
                class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
              />
              <div
                class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-20"
              ></div>

              <div
                class="agent-info-v2 tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-translate-y-full tw-transform tw-flex-col tw-items-center tw-gap-3 tw-overflow-hidden tw-p-3 tw-text-center !tw-text-white tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-pointer-events-auto group-hover:-tw-translate-y-8 group-hover:tw-opacity-100"
              >
                <div class="tw-flex tw-flex-col tw-gap-1">
                  <h4 class="tw-text-white">{{ member.member_name }}</h4>
                  <h6 class="n-semibold tw-mb-2 tw-text-white tw-opacity-90">{{ member.member_role }}</h6>
                  <h6 class="n-link tw-text-white">VIEW MORE DETAILS</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <MotionGroup :preset="vars.animationText || 'popVisible'" :duration="400" is="div">
      <popup v-if="selectedMember && popupConfig.isActive" :config="popupConfig" custom-width="90%">
        <template #content>
          <div class="tw-grid tw-h-full tw-w-full tw-grid-cols-12 tw-gap-y-4 tw-py-4 lg:tw-gap-x-6">
            <!-- Metin kısmı -->
            <div class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-justify-center lg:tw-col-span-7">
              <h2>{{ selectedMember.popup_title || selectedMember.member_name }}</h2>
              <h3 class="n-semibold tw-mt-2">{{ selectedMember.member_role }}</h3>

              <div class="tw-mt-3 tw-flex tw-flex-col tw-gap-3">
                <p>{{ selectedMember.popup_description }}</p>
              </div>
              <div class="tw-py-8">
                <div v-if="selectedMember.popup_mail" class="tw-flex tw-items-center tw-gap-1 tw-pb-3">
                  <nuxt-link :to="`mailto:${selectedMember.popup_mail}`" class="n-link">
                    <p class="n-semibold" style="color: var(--c-primary); text-transform: none !important">
                      {{ selectedMember.popup_mail }}
                    </p>
                  </nuxt-link>
                </div>
                <div v-if="selectedMember.popup_phone" class="tw-flex tw-items-center tw-gap-1">
                  <nuxt-link :to="`tel:${selectedMember.popup_phone}`" class="n-link">
                    <p class="n-semibold" style="color: var(--c-primary)">{{ selectedMember.popup_phone }}</p>
                  </nuxt-link>
                </div>
              </div>

              <nuxt-link
                v-if="selectedMember.button_link"
                :external="true"
                :class="`n-primary n-btn tw-mt-12 tw-max-w-fit`"
                :to="selectedMember.button_link"
              >
                <div class="n-btn-container">
                  <div class="n-btn-group">
                    <div class="n-btn-t1">{{ selectedMember.button_label }}</div>
                    <div class="n-btn-t2">{{ selectedMember.button_label }}</div>
                  </div>
                </div>
              </nuxt-link>
            </div>

            <!-- Medya kısmı (foto/video) -->
            <div
              class="tw-order-first tw-col-span-12 tw-flex tw-items-center tw-justify-center lg:tw-order-none lg:tw-col-span-5"
            >
              <div class="tw-w-full tw-max-w-[720px]">
                <!-- Video -->
                <div v-if="selectedMember?.popup_video">
                  <div
                    style="
                      position: relative;
                      width: 100%;
                      height: 100%;
                      aspect-ratio: 16/9;
                      border-radius: var(--rounded);
                    "
                  >
                    <iframe
                      :src="selectedMember.popup_video"
                      width="100%"
                      height="100%"
                      style="position: absolute; inset: 0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </popup>
    </MotionGroup>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Popup from '~/components/common/popup/Popup.vue';
import { Swiper as SwiperClass, SwiperSlide } from 'swiper/vue';
import { Pagination as SwiperPagination } from 'swiper';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  components: {
    Popup,
    Swiper: SwiperClass,
    SwiperSlide,
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return {
      selectedMember: null as any,
      swiper: null as any,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
      popupConfig: {
        isActive: false,
      },
      isVisible: false,
    };
  },

  computed: {
    members(): any[] {
      return (this as any).groupedVariables?.members || [];
    },
  },

  methods: {
    toggleTeamMemberDetailPopup(member: any = null, value = false) {
      if (member) {
        this.selectedMember = member;
        this.popupConfig.isActive = value;
      }
    },

    onSwiper(swiperInstance: any) {
      this.swiper = swiperInstance;
      this.onSlideChange();
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = (this.swiper as any).isBeginning;
      const isAtEnd = (this.swiper as any).isEnd;
      this.canPaginateBack = !isAtStart;
      this.canPaginateNext = !isAtEnd;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>

<style scoped>
@media (hover: none) {
  .no-hover .shine-effect {
    filter: none;
  }

  .no-hover .shine {
    opacity: 30%;
  }

  .no-hover .agent-info-v2 {
    opacity: 100%;
    pointer-events: auto;
    transform: translateY(-4rem);
  }
  .no-hover .agent-info-v1 {
    opacity: 100%;
    pointer-events: auto;
    transform: translateY(0px);
  }
}
</style>
